import type { ComponentType, ReactNode, SVGProps } from 'react';
import { ModalComponentWrapper } from '@/shared/components';
import { DepositInstructionContent } from './DepositInstructionContent';

type DepositMethod = 'oplati' | 'erip';

interface DepositInstructionModalProps {
  onBack?: () => void;
  onClose?: () => void;
  title: string;
  depositMethod: DepositMethod;
  icon?: ComponentType<SVGProps<SVGSVGElement>> | ReactNode | string;
}

export function DepositInstructionModal({
  onBack,
  title,
  depositMethod,
  icon,
}: DepositInstructionModalProps) {
  return (
    <ModalComponentWrapper title={title} onBack={onBack || (() => {})}>
      <DepositInstructionContent depositMethod={depositMethod} icon={icon} />
    </ModalComponentWrapper>
  );
}
